import { Reveal } from "./Reveal";

// One of the homepage umbrella blocks: H2, then its sub-sections.
export default function UmbrellaBand({ id, title, children }) {
  return (
    <section id={id} className="border-t border-hairline" data-testid={`${id}-band`}>
      <div className="site-x pt-12 sm:pt-16">
        <Reveal>
          <h2 className="font-head font-extrabold tracking-tight h-sec">{title}</h2>
        </Reveal>
      </div>
      {children}
    </section>
  );
}
